import { Component, EventEmitter, Input, Output } from "@angular/core";
import { environment as appEnv } from "../../../environments/environment";

@Component({
  selector: "ab-add-slack-callout",
  templateUrl: "./add-slack-callout.component.html",
})
export class AddSlackCalloutComponent {
  @Input() public project: any;
  @Output() public dismissAndFollowLink = new EventEmitter<void>();

  public appEnv = appEnv;

  public dismissAndFollow(event: any) {
    this.dismissAndFollowLink.emit(event);
  }
}
